import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { userAuthApi } from '../services/userAuth';
import loginAuthReducer, { sliceName as authSliceKey } from '../pages/login-page/LoginAuthSlice';
import redirectReducer, { sliceName as redirectSliceKey } from '../components/redirect/redirectSlice';
import recruitmentReducer, { sliceName as recruitmentSliceKey } from '../pages/recruitment/RecruitmentDataSlice'
import { rtkQueryErrorLogger } from './middleware';
// persists store
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers } from 'redux';
import { countriesApi } from '../services/countries';
import { birthdayApi } from '../services/birthday/birthdays'

const reducers = combineReducers({
  [userAuthApi.reducerPath]: userAuthApi.reducer,
  [countriesApi.reducerPath]: countriesApi.reducer,
  [birthdayApi.reducerPath]: birthdayApi.reducer,
  [redirectSliceKey]: redirectReducer,
  [authSliceKey]: loginAuthReducer,
  [recruitmentSliceKey]: recruitmentReducer
})

const persistedReducer = persistReducer({
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: [authSliceKey]
}, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
    }
  }).concat(
    rtkQueryErrorLogger,
    countriesApi.middleware,
    birthdayApi.middleware,
  )
});


setupListeners(store.dispatch);